export const getIsMaterialVariantLabel = (label: string | undefined) => {
	if (typeof label !== "string") {
		return false;
	}

	return label.startsWith("Matière");
};
